module.exports = __webpack_public_path__ + "img/0Q3A3407_L_BlackMatted.d033870b.jpg";